"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateHeight = void 0;
const calculateHeight = (element) => {
    return new Promise(resolve => {
        const clone = element.cloneNode(true);
        const rect = element.getBoundingClientRect();
        clone.style.position = 'absolute';
        clone.style.top = '0';
        clone.style.left = '0';
        clone.style.width = `${rect.width}px`;
        clone.style.height = 'unset';
        clone.style.opacity = '0';
        document.body.appendChild(clone);
        requestAnimationFrame(() => {
            const cloneRect = clone.getBoundingClientRect();
            clone.remove();
            resolve(cloneRect.height);
        });
    });
};
exports.calculateHeight = calculateHeight;
